import React from "react";
import {HtmlDisplay} from "../Display";
import {GridCell} from "../Grid";
import {Notification} from "./Notification";

interface DisplayLayoutProps {
	children: React.ReactNode;
	error?: string;
	label: string;
	medium_columns?: string;
	name: string;
}

const DisplayLayout: React.FC<DisplayLayoutProps> = ({children, error, label, medium_columns, name}: DisplayLayoutProps) => {
	return (
		<GridCell medium_columns={medium_columns}>
			<HtmlDisplay className={`label`} html={label} name={name}/>
			<div aria-labelledby={name}>
				{children}
			</div>
			<Notification error={error} name={name} label={label}/>
		</GridCell>
	);
};

export {DisplayLayout};
